import { render, staticRenderFns } from "./CapsuleCollider.vue?vue&type=template&id=7613d413&scoped=true&"
import script from "./CapsuleCollider.vue?vue&type=script&lang=js&"
export * from "./CapsuleCollider.vue?vue&type=script&lang=js&"
import style0 from "./CapsuleCollider.vue?vue&type=style&index=0&id=7613d413&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7613d413",
  null
  
)

export default component.exports